import type { IShopper } from '@makemydeal/dr-platform-types';
import { resolveCellPhone } from '@makemydeal/dr-shared-ui-utils/phone/resolvePhone';

import type { CustomerFormValues } from '../types/CustomerCardTypes';
import type { CreateConsumerRequest } from '../types/consumer.types';

export const mapFormValuesToCreateConsumerPayload = (
    formValues: CustomerFormValues | IShopper,
    enableCorrectPhoneHandling: boolean
): CreateConsumerRequest => ({
    title: formValues.title,
    firstName: formValues.firstName,
    middleName: formValues.middleName,
    lastName: formValues.lastName,
    suffix: formValues.suffix,
    email: formValues.email,
    emailAlternative: formValues.emailAlternative,
    phone: enableCorrectPhoneHandling ? resolveCellPhone(formValues) : formValues.phone,
    homePhone: formValues.homePhone,
    workPhone: formValues.workPhone,
    address: {
        streetAddress: formValues.streetAddress,
        streetAddress2: formValues.streetAddress2,
        city: formValues.city,
        state: formValues.state,
        zip: formValues.zip,
        county: formValues.county
    }
});
